import React, { useEffect, useState } from "react";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import AddPipelines from "./AddPipelines";
import UpdatePipelines from "./UpdatePipelines";
import GeneralTable from "../../../commons/GeneralTable";
import DropdownComp from "../../../commons/Dropdowns/DropdownComp";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import PageToolbar from "../../../design-system/PageToolbar";

import { useTranslation } from "react-i18next";
const ServiceProviderPipelines = () => {
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(9);
  const [data, setData] = useState([
    {
      _id: "qjwdn329e3",
      title: t("Prospecting"),
      noOfDeals: "20"
    },
    {
      _id: "123123123dqwwdq",
      title: t("Qualification"),
      noOfDeals: "20"
    },
    {
      _id: "123123123dqwwdq",
      title: t("Appointment"),
      noOfDeals: "30"
    },
    {
      _id: "123123123dqwwdq",
      title: t("Demo"),
      noOfDeals: "20"
    },
    {
      _id: "123123123dqwwdq",
      title: t("Negotiation"),
      noOfDeals: "30"
    },
    {
      _id: "123123123dqwwdq",
      title: t("Closing"),
      noOfDeals: "20"
    }
  ]);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const getData = async () => {};

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/pipelines/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1
    },
    {
      title: t("Title"),
      dataIndex: "title",
      mobile: "title",
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      title: t("No Of Deals"),
      dataIndex: "noOfDeals",
      sorter: (a, b) => a.noOfDeals - b?.noOfDeals
    }
    // {
    //   title: t("Action"),
    //   key: "action",
    //   mobile: "actions",
    //   render: (text, obj) => {
    //     const menuItems = [
    //       {
    //         key: "edit",
    //         component: () => <UpdatePipelines data={obj} updateParent={getData} />
    //       },
    //       {
    //         key: "delete",
    //         component: () => (
    //           <DeleteModal text="Department" onClick={() => deleteHandler(obj?._id)} />
    //         )
    //       }
    //     ];
    //     return (
    //       <div className="d-flex gap-1 align-items-center">
    //         <DropdownComp menuItems={menuItems} />
    //       </div>
    //     );
    //   }
    // }
  ];

  return (
    <div className="pipelines-page">
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        // actions={<AddPipelines updateParent={getData} />}
      />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
      />
    </div>
  );
};

export default ServiceProviderPipelines;
